export const getPageIndex = (page: Element) => {
  const pageIndex = page.getAttribute('page');

  return pageIndex !== null ? Number(pageIndex) : undefined;
};
